/**
 * @description 公共语言包 中文
 */
export default {
  // 通用
  Common: {
    // 工作流相关的通用语言包
    Workflow: {
      State: "工作流状态",
      StateName: "状态名称",
      StateOptions: {
        Complete: "完成",
        Cancel: "取消",
        "NEW": "新建",
        ToBeModified: "待修改",
        InProgress: "流程中",
        Issued: "已提交",
        Void: "作废",
      },
      // 办理
      Handle: {
        // 办理
        Title: "办理",
        // 办理意见
        Comment: "办理意见",
        // 办理人
        Handler: "办理人",
        // 办理时间
        HandleTime: "办理时间",
        // 办理结果
        HandleResult: "办理结果",
      },
      ChangeState: {
        ActionLabel: "请选择",
        VerifyAccount: "验证",
        Username: "用户名",
        Password: "密码",
        Reason: "原因",
        // 请输入用户名
        PleaseEnterUsername: "请输入用户名",
        // 请输入密码
        PleaseEnterPassword: "请输入密码",
        // 账号名或密码错误
        UsernameOrPasswordError: "账号名或密码错误",
        // 请选择一个执行动作
        PleaseChooseAction: "请选择一个执行动作",
        Confirm: "确认",
        OperateSuccess: "操作成功",
        OperateFail: "操作失败",
      },
      History: {
        // 历史记录
        Title: "审批历史",
        // 任务名称
        TaskName: "任务名称",
        // 审批人
        HandlerNickname: "审批人",
        // 审批开始时间
        HandleStartTime: "审批开始时间",
        // 审批结束时间
        HandleEndTime: "审批结束时间",
        // 审批结果
        HandleResult: "审批结果",
        // 审批意见
        Comment: "审批意见",
      }
    },
    // 任务单相关的通用语言包
    TaskOrder: {
      State: "状态",
      StateName: "状态名称",
      // 创建人
      Creator: "创建人",
      // 创建时间
      CreateTime: "创建时间",
      // 审核人
      Confirmer: "审核人",
      // 审核时间
      ConfirmTime: "审核时间",
      Note: "备注",
    },
    Button: {
      // 新增
      Add: "新增",
      // 编辑
      Edit: "编辑",
      // 删除
      Delete: "删除",
      // 保存
      Save: "保存",
      // 取消
      Cancel: "取消",
      // 确定
      Confirm: "确定",
      // 重置
      Reset: "重置",
      // 查询
      Query: "查询",
      // 提交
      Submit: "提交",
      // 办理
      Handle: "办理",
      // 退回
      Back: "退回",
      // 拾取
      Claim: "拾取",
      // 作废
      Void: "作废",
    },
    Toast: {
      // 保存成功
      SaveSuccess: "保存成功",
      // 保存失败
      SaveFailed: "保存失败",
      // 删除成功
      DeleteSuccess: "删除成功",
      // 删除失败
      DeleteFailed: "删除失败",
      // 提交成功
      SubmitSuccess: "提交成功",
      // 提交失败
      SubmitFailed: "提交失败",
      // 请选择至少一条数据
      ChooseOneData: "请选择至少一条数据",
    },
    Options: {
      Yes: "是",
      No: "否",
      // 有效
      Valid: "有效",
      // 无效
      Invalid: "无效",
    },
    // 性别可选项
    GenderOptions: {
      // 男
      Male: "男",
      // 女
      Female: "女",
      // 未知
      Unknown: "未知",
    },
    // 校验
    Validate: {
      // 请输入
      PleaseEnter: "请输入",
      // 请选择
      PleaseChoose: "请选择",
      // 请输入正确的
      PleaseEnterCorrect: "请输入正确的",
      // 必填项未填写
      RequiredNotFilled: "必填项未填写",
      // 请填写必填项
      PleaseFillRequired: "请填写必填项",
    },
    NoOptions: "没有可用的选项",
    Yes: "是",
    No: "否",
    Cancel: "取消",
    Confirm: "确认",
    CreateUser: "创建人",
    Creator: "创建人",
    CreateDate: "创建时间",
    CreateTime: "创建时间",
    // 保存成功
    SaveSuccess: "保存成功",
    SaveFail: "保存失败",
    PleaseEnter: "请输入",
    PleaseChoose: "请选择",
    PleaseChooseData: "请选择数据",
    ConfirmDate: "审核时间",
    ConfirmUser: "审核人",
    AddSuccess: "添加成功",
    AddFail: "添加失败",
    // 请选择至少一条数据
    ChooseOneData: "请选择至少一条记录",
    UserName: "用户名",
    NickName: "姓名",
    Username: "用户名",
    Nickname: "姓名",
    EditInfo: "编辑信息",
    Note: "备注",
    // 操作成功
    OperateSuccess: "操作成功",
    OperateFail: "操作失败",
    // 批量录入
    BatchInput: "批量录入",
    BatchAdd: "批量添加",
    State: "状态",
    DeleteSuccess: "删除成功",
    DeleteFail: "删除失败",
    // 合格
    Qualified: "合格",
    // 不合格
    Unqualified: "不合格",
    ID: "编号",
    // 编码
    Code: "编码",
    Name: "名称",
    Label: "标签",
    ChooseApprover: "选择审核人",
    Description: "描述",
    Save: "保存"
  },
  OrderList:{
    save:"preservation",
    back:"List",
    items:"Navigation",
    submit:"Submit",
    state:"State",
    saveAnd:"Save and execute",
    orderInfo:"Order Information",
    List:"List",
    Cancel:"Cancel",
    Modify:"Modify",
    //附件
    upload:"Upload Attachment",
    view:"Check Attachment",
  },

}